<template>
  <table class="listado table table-hover">
    <thead class="bg-primary text-white">
      <th-ordenado titulo="Nombre" campo="nombre" />
      <th class="th-acciones">Acciones</th>
    </thead>
    <tbody>
      <sin-registros v-if="!formasPago" :colspan="4" />
      <tr v-for="formaPago in formasPago" :key="formaPago.id" role="button">
        <td @click="editarFormaPago(formaPago.id)">
          {{ formaPago.nombre }}
        </td>
        <td nowrap="nowrap" class="td-acciones">
          <b-button-group size="sm">
            <b-button variant="primary" class="actionButton" :to="`/formasPago/editar/${formaPago.id}`">
              <v-icon variant="primary" name="edit" width="16" /><span>Editar</span>
            </b-button>
          </b-button-group>
        </td>
      </tr>
    </tbody>
  </table>
</template>
<script>
export default {
  props: {
    formasPago: Array,
  },
  methods: {
    editarFormaPago(formaPagoId) {
      this.$router.push("/formasPago/editar/" + formaPagoId);
    },
  },
};
</script>
